module.exports = __webpack_public_path__ + "static/media/inactiveuser.9438ec22.png";